import { render, staticRenderFns } from "./BuyKitCart.vue?vue&type=template&id=6bb1f15e"
import script from "./BuyKitCart.vue?vue&type=script&lang=js"
export * from "./BuyKitCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports